interface Props {
  hidden?: boolean;
  inline?: boolean;
  className?: string;
}

function BetaLabel(props: Props) {
  const { hidden, inline, className } = props;

  if (hidden)
    return null;

  return (
    <span className={`${inline ? "inline-flex" : "flex"} flex items-center gap-1 bg-blue/20 px-1 py-0.5 rounded-sm text-blue text-xs font-gilroy font-semibold ml-auto h-min uppercase ${className ?? ""}`}>
      Beta
    </span>
  );
}

export default BetaLabel;
